<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
@if (layout === 'centered') {
    <centered-layout></centered-layout>
}

<!-- Enterprise -->
@if (layout === 'enterprise') {
    <enterprise-layout></enterprise-layout>
}

<!-- Material -->
@if (layout === 'material') {
    <material-layout></material-layout>
}

<!-- Modern -->
@if (layout === 'modern') {
    <modern-layout></modern-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
@if (layout === 'classic') {
    <classic-layout></classic-layout>
}

<!-- Classy -->
@if (layout === 'classy') {
    <classy-layout></classy-layout>
}

<!-- Compact -->
@if (layout === 'compact') {
    <compact-layout></compact-layout>
}

<!-- Dense -->
@if (layout === 'dense') {
    <dense-layout></dense-layout>
}

<!-- Futuristic -->
@if (layout === 'futuristic') {
    <futuristic-layout></futuristic-layout>
}

<!-- Thin -->
@if (layout === 'thin') {
    <thin-layout></thin-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Mobile layout (PWA) -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'mobile') {
    <mobile-layout></mobile-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Kiosk layout (42" portrait panel) -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'kiosk') {
    <kiosk-layout></kiosk-layout>
}

@if (videoCallsEnabled && layout !== 'empty' && layout !== 'kiosk') {
    <video-call-drawer presentation="popover"></video-call-drawer>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Admin & Production (full) and Trader / Sales (trimmed: theme + landing workspace) -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (isAdmin || isTrader || isSales) {
    <settings></settings>
}

